import ali_nankali from './panel_members/ali.jpg'
import drAlkherayf from './panel_members/alKherayf.jpg'
import drAmmaar from './panel_members/ammaar.jpg'
import drBeatriz from './panel_members/beatriz.jpg'
import drMed from './panel_members/med.jpg'
import drSupaprawat from './panel_members/supaprawat.jpg'
import drTarek from './panel_members/tarek.jpg'
import eman from './panel_members/eman.jpg'
import martin from './panel_members/martin.jpg'

import ali_banner from "./panelm_banners/ali_banner.jpg";
import emanAlsheikh_banner from "./panelm_banners/eman_banner.jpg";
import drSupaprawat_banner from "./panelm_banners/supaprawat_banner.jpg";
import drMed_banner from "./panelm_banners/med_banner.jpg";
import drMartin_banner from "./panelm_banners/martin_banner.jpg";
import drBeatriz_banner from "./panelm_banners/beatriz_banner.jpg";
import drAmmaar_banner from "./panelm_banners/ammaar_banner.jpg";
import drAlkherayf_banner from "./panelm_banners/alkherayf_banner.jpg";
import tarek_banner from './panelm_banners/tarek_banner.jpg'


export const panel_members_about = [
  {
    id: "ali-nankali",
    image: ali_nankali,
    name: "Prof. Ali Nankali",
    from: "",
    about: "",
    link: "/panel/ali-nankali",
  },
  {
    id: "dr-alkherayf",
    image: drAlkherayf,
    name: "Dr.AlKherayf ",
    from: "Canada",
    about: "",
    link: "/panel/dr-alkherayf",
  },
  {
    id: "dr-ammaar",
    image: drAmmaar,
    name: "Dr. Ammaar",
    from: "",
    about: "",
    link: "/panel/dr-ammaar",
  },
  {
    id: "dr-beatriz",
    image: drBeatriz,
    name: "Dr. Beatriz Chaves",
    from: "",
    about: "",
    link: "/panel/dr-beatriz",
  },
]

export const panel_members = [
  {
    id: "ali-nankali",
    image: ali_nankali,
    name: "Prof. Ali Nankali",
    from: "",
    about: "",
    link: "/panel/ali-nankali",
  },
  {
    id: "dr-alkherayf",
    image: drAlkherayf,
    name: "Dr.AlKherayf ",
    from: "Canada",
    about: "",
    link: "/panel/dr-alkherayf",
  },
  {
    id: "dr-ammaar",
    image: drAmmaar,
    name: "Dr. Ammaar",
    from: "",
    about: "",
    link: "/panel/dr-ammaar",
  },
  {
    id: "dr-beatriz",
    image: drBeatriz,
    name: "Dr. Beatriz Chaves",
    from: "",
    about: "",
    link: "/panel/dr-beatriz",
  },
  {
    id: "dr-med",
    image: drMed,
    name: "Dr. Med",
    from: "",
    about: "",
    link: "/panel/dr-med",
  },
  {
    id: "dr-supaprawat",
    image: drSupaprawat,
    name: "Dr. Supaprawat",
    from: "",
    about: "",
    link: "/panel/dr-supaprawat",
  },
  {
    id: "dr-tarek",
    image: drTarek,
    name: "Dr. Tarek Assi",
    from: "",
    about: "",
    link: "/panel/dr-tarek",
  },
  {
    id: "eman-alsheikh",
    image: eman,
    name: "Eman Alsheikh",
    from: "",
    about: "",
    link: "/panel/eman-alsheikh",
  },
  {
    id: "martin-levine",
    image: martin,
    name: "Martin Levine",
    from: "",
    about: "",
    link: "/panel/martin-levine",
  },
];

export const ali_nankali_data = {
  image: ali_nankali,
  from: "Barts and The London Medical and Dental School, UK",
  about:
    "Dr. Ali Nankali is a Clinical Reader in Digital Dentistry at the Teaching and Innovation (Adult Oral Health) Centre, Barts and The London Medical and Dental School. With a PhD from the National Medical University in Kiev, Ukraine, and a background in engineering, he has developed key dental innovations such as the Nankali Post System and Nankali bur. His research focuses on masticatory force distribution and mechanical resilience of dental tissues. He mentors postgraduate and PhD students and frequently leads CPD and specialist courses.",
  name: "Prof. Ali Nankali",
  banner: ali_banner,
};

export const alkherayf_data = {
  image: drAlkherayf,
  from: "University of Ottawa, Canada",
  about: "Dr. AlKherayf is an Assistant Professor, a Residency Program Director, and a Neurosurgeon at the University of Ottawa. He is also an Associate Scientist in the Clinical Epidemiology Program at the Ottawa Hospital Research Institute (OHRI) with a cross appointment to the Neuroscience Program. He serves as Director of the Clinical Research Program at The Ottawa Hospital, Division of Neurosurgery, and leads the Spine Fellowship and Combined Skull Base Fellowship Programs at the University of Ottawa.",
  name: "Dr. AlKherayf",
  banner: drAlkherayf_banner,
};

export const ammaar_data = {
  image: drAmmaar,
  from: "Lincoln Memorial University, US",
  about:
    "Dr. Ammaar Abidi is the Director of Bioscience and an Associate Professor of Pharmacology at Lincoln Memorial University, College of Dental Medicine. Dr. Abidi graduated with a dual degree (D.D.S/Ph.D.) at the University of Tennessee Health Science Center, Memphis, TN. Dr. Abidi’s career has been focused on combining his basic science knowledge of periodontal cells, cellular/molecular signaling, pharmacology, inflammation, and therapeutics to help evolve the current clinical therapies for oral inflammation. He has been actively presenting and lecturing on developing novel approaches to regulate oral pain and uncontrolled inflammation signaling to improve public oral and systemic health.",
  name: "Dr. Ammaar Abidi",
  banner: drAmmaar_banner,
};

export const beatriz_data = {
  image: drBeatriz,
  from: "University of the Basque Country",
  about:
    "Dr. Beatriz Chaves is a distinguished implantologist and oral surgeon with a deep passion for rehabilitation and implantology. With a wealth of experience in complex surgeries and rehabilitations, she has held senior roles in prestigious institutions across Spain. Dr. Chaves is dedicated to excellence in her field, specializing in periodontal plastic surgery, bone regeneration, implants, and the rehabilitation of the atrophic maxilla. She holds a Master’s Degree in Periodontics and Implantology from the University of the Basque Country and is a Specialist in Implant Prosthesis from the Complutense University of Madrid. Dr. Chaves has also pursued advanced continuing education in bone regeneration, mucogingival surgery, and oral rehabilitation. Since 2010, she has maintained an exclusive private practice focused on oral surgery and rehabilitation.",
  name: "Dr. Beatriz Chaves",
  banner: drBeatriz_banner,
};

export const med_data = {
  image: drMed,
  from: "Sana Hospitals Duisburg",
  about:
    "Prof. Dr. med. Martin Scholz is the Head of the Department for Neurosurgery and Neurosurgical Intensive Care Medicine at Sana Hospitals Duisburg, one of the largest neurosurgical departments in Germany with expertise in all areas of microsurgery and neuroendoscopy. At the Neuro Center, the professional competence of the neurosurgery department is complemented by close cooperation with other departments of Sana Hospitals Duisburg, including the specialties of neuroradiology, neurology, neurological early rehabilitation, oncology, radiotherapy, pediatrics and neuropediatrics. With more than 35 years of experience and continuous national and international training courses, Prof. Dr. med. Martin Scholz and his team aim to provide the best possible treatment. Throughout his long-standing experience as a neurosurgeon, he has received several awards and certificates, including the following: Certificate 'Special Neurological Oncology', Certificate 'Vascular Neurosurgery' and Certificate 'Spinal Neurosurgery'.",
  name: "Prof. Dr. med. Martin Scholz",
  banner: drMed_banner,
};

export const supaprawat_data = {
  image: drSupaprawat,
  from: "Manipal GlobalNxt University, Malaysia",
  about:
    "Dr. Supaprawat Siripipatthanakul is an Adjunct Professor in Oral Medicine at Manipal GlobalNxt University in Malaysia. He holds multiple degrees, including a PhD (Ed), DBA, DDS, and MS in both Management and Oral Medicine. He is also a Faculty Member and Researcher at Manipal GlobalNxt University. Dr. Siripipatthanakul's professional affiliations extend to other institutions, including Bangkok Thonburi University and Universitas Terbuka, Indonesia, where he serves as a Visiting Professor.",
  name: "Dr. Supaprawat Siripipatthanakul",
  banner: drSupaprawat_banner,
};

export const tarek_assi_data = {
  image: drTarek,
  name: "Dr. Tarek Assi",
  from: "Alpha Dental Practice & Implant Center, USA",
  about:
    "Dr. Tarek Assi is the founder of Alpha Dental Practice & Implant Center in the USA, specializing in Implant Dentistry with a prosthetic-driven, digital-first approach. A Diplomate of the American Board of Oral Implantology and multiple international implantology organizations, he earned his DMD from Nova Southeastern University and completed advanced training at the Misch Implant Institute. Dr. Assi is a nationally recognized lecturer and published author, dedicated to sharing knowledge through study clubs and dental missions.",
  banner: drMartin_banner,
  link: "/panel/dr-tarek",
};

export const eman_alsheikh_data = {
  image: eman,
  name: "Eman Alsheikh",
  from: "International University of Africa / University of Science and Technology, Sudan",
  about:
    "Eman Alsheikh is an experienced Dental Specialist with expertise in teaching, clinical research, and laboratory-based studies. She is a skilled mentor and communicator, adept in multiple languages, and has taught both undergraduate and postgraduate dental students. Her work focuses on advancing Oral Medicine and Clinical Dentistry through academic, research, and clinical contributions in higher education and healthcare systems.",
  banner: emanAlsheikh_banner,
  link: "/panel/eman-alsheikh",
};

export const martin_levine_data = {
  image: martin,
  name: "Martin Levine",
  from: "University of Oklahoma Health Sciences Center / University of Glasgow",
  about:
    "Martin Levine began his dental career with a BDS from the University of Glasgow and worked in the UK NHS. Encouraged by his wife, he pursued a BSc in Biochemistry and a PhD at the University of Glasgow. He completed a fellowship at the University of Washington and later taught at SUNY Buffalo. In 1976, he joined the University of Oklahoma Health Sciences Center, where he became a tenured associate professor and adjunct faculty at the College of Dentistry. Retiring in 2019 and 2023, he continues as volunteer faculty, collaborating on periodontitis research. He co-founded 'PerioImm' to develop genetic testing for susceptibility to periodontitis and related conditions, with a pending patent in the US and Hungary.",
  banner: drMartin_banner,
  link: "/panel/martin-levine",
};
